export enum ModalStatusSubmitReviewEnums {
	INACTIVE = 'inactive',
	CONFIRMATION = 'confirmation',
	LATER = 'later'
}
